import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { RentalBurdenRecord } from './useRentalBurdenData';
import { Place } from '@/types';

interface PeerRentalBurdenData {
  [key: string]: RentalBurdenRecord[]; // key is place_fips
}

export function usePeerRentalBurdenData(peers: Place[]) {
  const [data, setData] = useState<PeerRentalBurdenData>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!peers.length) {
      setLoading(false);
      setData({});
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // Create an array of promises for each peer
    const fetchPromises = peers.map(peer => 
      supabase
        .from('acs_bps_metrics_rental_affordability')
        .select('*')
        .eq('Place', peer.name)
        .eq('place_fips', peer.place_fips)
        .order('year', { ascending: false })
        .limit(1) // We only need the most recent year for ranking
    );

    Promise.all(fetchPromises)
      .then(results => {
        const newData: PeerRentalBurdenData = {};
        let loggedAny = false;
        results.forEach((result, index) => {
          if (result.error) {
            console.error(`Error fetching data for peer ${peers[index].name}:`, result.error);
          } else {
            const peerData = result.data || [];
            newData[peers[index].place_fips] = peerData;
            // Log the rental burden data for this peer
            const latestData = peerData[0];
            if (latestData) {
              loggedAny = true;
              console.log(`Peer City: ${peers[index].name}`);
              console.log(`  FIPS: ${peers[index].place_fips}`);
              console.log(`  Rent Burden Share: ${latestData.rent_burden_share?.toFixed(2)}%`);
              console.log(`  Year: ${latestData.year}`);
            }
          }
        });
        if (loggedAny) {
          console.log('------------------------');
        }
        setData(newData);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching peer rental burden data:', err);
        setError('Failed to fetch peer data');
        setLoading(false);
      });
  }, [peers]);

  return { data, loading, error };
} 